var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggageTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.93305C0 3.19549 0.595882 2.59961 1.33344 2.59961H4.3712C5.51712 2.59961 6.53804 3.33301 6.90056 4.42475L10.7384 15.934C11.9926 15.9549 13.1052 16.5549 13.822 17.4758L22.2434 14.6673C22.9436 14.4339 23.6978 14.8131 23.9312 15.509C24.1644 16.2049 23.7852 16.9633 23.0894 17.1966L14.6679 20.0052C14.6304 22.1804 12.8552 23.9346 10.6675 23.9346C8.45902 23.9346 6.66722 22.1428 6.66722 19.9344C6.66722 18.6509 7.27142 17.5092 8.209 16.7758L4.3712 5.26649H1.33344C0.595882 5.26649 0 4.67061 0 3.93305ZM10.2008 8.20423C9.97166 7.50417 10.355 6.74995 11.0551 6.52493L12.9594 5.90821L13.7845 8.44593L16.3222 7.62085L15.4929 5.08315L17.3973 4.46643C18.0973 4.23725 18.8515 4.62061 19.0766 5.32067L21.135 11.6628C21.3642 12.3629 20.9808 13.1171 20.2808 13.3421L13.9386 15.4007C13.2386 15.6299 12.4844 15.2465 12.2593 14.5464L10.2008 8.20423Z",
    fill: "#F28520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 8.2046C9.97198 7.50454 10.3553 6.7503 11.0554 6.52528L12.9597 5.90856L13.7848 8.44628L16.3225 7.62122L15.4933 5.0835L17.3976 4.46678C18.0976 4.2376 18.8519 4.62096 19.0769 5.32102L21.1353 11.6632C21.3645 12.3633 20.9813 13.1175 20.2811 13.3425L13.939 15.401C13.2389 15.6302 12.4847 15.2468 12.2597 14.5468L10.2012 8.2046Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageTrolley);
export default __webpack_public_path__ + "static/media/luggage-trolley.3577abf0ba981b782fa568d1dfdf64c9.svg";
export { ForwardRef as ReactComponent };